// ============================================================
//  CONTENU DU SITE — modifiez uniquement ce fichier.
//  Chaque rubrique correspond à un objet cliquable de la chambre.
//  Vidéos : collez simplement le lien YouTube ou Vimeo normal.
//  Images : URL d'image, ou fichier placé dans /public/images (ex. "/images/photo1.jpg").
// ============================================================

export const profile = {
  firstName: "Malwen",
  lastName: "Fillon",
  role: "Réalisateur · Monteur · Vidéaste",
  location: "Lyon, France",
  tagline: "Je raconte des histoires à hauteur d'humain, en lumière naturelle et en plans qui respirent.",
  email: "contact@exemple.com",
  phone: "+33 6 00 00 00 00",
  availability: "Disponible pour tournages & montages — 2026",
  socials: [
    { label: "Instagram", url: "https://instagram.com/" },
    { label: "Vimeo", url: "https://vimeo.com/" },
    { label: "LinkedIn", url: "https://linkedin.com/" },
  ],
};

// Titres et petites phrases d'accroche de chaque objet (survol + panneau)
export const sections = {
  about: { label: "Me présenter", object: "Le petit homme au bureau" },
  films: { label: "Courts-métrages & projets", object: "La caméra cinéma" },
  photos: { label: "Photographies", object: "L'appareil photo" },
  experience: { label: "Expériences pro", object: "Le clap de tournage" },
  education: { label: "Parcours scolaire", object: "Le diplôme encadré" },
  skills: { label: "Compétences & logiciels", object: "La bibliothèque" },
  languages: { label: "Langues & voyages", object: "Le globe" },
  art: { label: "Peintures & arts", object: "Les toiles au mur" },
  music: { label: "Goûts musicaux", object: "Le tourne-disque" },
  sports: { label: "Sports", object: "Les haltères" },
  associative: { label: "Vie associative", object: "Le trophée" },
  contact: { label: "Me contacter", object: "Le téléphone rétro" },
};

export const about = {
  portrait: "https://images.unsplash.com/photo-1611784728558-6c7d9b409cdf?crop=entropy&cs=srgb&fm=jpg&w=800&q=85",
  paragraphs: [
    "Vidéaste de 26 ans basé à Lyon, j'écris, je filme et je monte des courts-métrages depuis l'adolescence. Mon terrain de jeu : les histoires intimes, les visages, la lumière de fin de journée.",
    "Formé à l'image puis au montage, j'aime accompagner un projet de l'écriture à l'étalonnage — pour la fiction, le clip comme pour le documentaire.",
  ],
  quote: "« Un bon plan, c'est un silence qu'on a pris le temps d'écouter. »",
  facts: [
    { label: "Âge", value: "26 ans" },
    { label: "Basé à", value: "Lyon" },
    { label: "Permis", value: "B — véhiculé" },
    { label: "Films réalisés", value: "7" },
  ],
};

export const films = [
  {
    title: "Les Heures Dorées",
    year: "2025",
    role: "Réalisation, image",
    duration: "14 min",
    genre: "Fiction",
    synopsis: "Un été, deux frères et le dernier jour d'une maison de famille avant sa vente.",
    thumbnail: "https://images.unsplash.com/photo-1619099619226-f96e319e3732?crop=entropy&cs=srgb&fm=jpg&w=800&q=85",
    video: "https://www.youtube.com/watch?v=aqz-KE-bpKQ",
  },
  {
    title: "Nuit Blanche",
    year: "2024",
    role: "Réalisation, montage",
    duration: "9 min",
    genre: "Thriller",
    synopsis: "Une veilleuse de nuit dans un hôtel vide reçoit un appel qui n'aurait jamais dû arriver.",
    thumbnail: "https://images.unsplash.com/photo-1681137063068-081072cf04b4?crop=entropy&cs=srgb&fm=jpg&w=800&q=85",
    video: "https://www.youtube.com/watch?v=eRsGyueVLvQ",
  },
  {
    title: "Atelier",
    year: "2024",
    role: "Documentaire — réalisation",
    duration: "18 min",
    genre: "Documentaire",
    synopsis: "Portrait d'une céramiste qui reprend l'atelier de sa grand-mère dans la Drôme.",
    thumbnail: "https://images.unsplash.com/photo-1632187981988-40f3cbaeef5e?crop=entropy&cs=srgb&fm=jpg&w=800&q=85",
    video: "https://www.youtube.com/watch?v=R6MlUcmOul8",
  },
  {
    title: "Rivière — clip",
    year: "2023",
    role: "Clip musical — image & montage",
    duration: "3 min 40",
    genre: "Clip",
    synopsis: "Clip pour le groupe lyonnais Les Marées, tourné en une nuit au bord du Rhône.",
    thumbnail: "https://images.unsplash.com/photo-1612544409025-e1f6a56c1152?crop=entropy&cs=srgb&fm=jpg&w=800&q=85",
    video: "https://vimeo.com/76979871",
  },
];

export const photos = [
  { src: "https://images.unsplash.com/photo-1570587726545-494e2bcc2f9f?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85", caption: "Lumière rasante — Lyon, 2025" },
  { src: "https://images.unsplash.com/photo-1722153023306-a0618a3340c6?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85", caption: "Rue la nuit — 2024" },
  { src: "https://images.unsplash.com/photo-1501396358880-2d8f6ace3fc7?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85", caption: "Passant — série « Ombres »" },
  { src: "https://images.unsplash.com/photo-1693845609818-0ab52b23dd71?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85", caption: "Ruelle — voyage, 2023" },
  { src: "https://images.unsplash.com/photo-1632187989763-c9c620420b4d?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85", caption: "Plateau — Les Heures Dorées" },
  { src: "https://images.unsplash.com/photo-1497015289639-54688650d173?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85", caption: "Repérages — 2024" },
];

export const experience = [
  { period: "2024 — aujourd'hui", title: "Vidéaste indépendant", company: "Freelance", place: "Lyon", description: "Clips, films d'entreprise et captations pour artistes et institutions culturelles." },
  { period: "2023 — 2024", title: "Assistant monteur", company: "Studio Lumen Productions", place: "Paris", description: "Dérushage, synchronisation et pré-montage sur deux documentaires TV." },
  { period: "2022", title: "Assistant caméra (stage)", company: "Long-métrage « Les Rives »", place: "Annecy", description: "Gestion du matériel, clap, data management sur 6 semaines de tournage." },
];

export const education = [
  { period: "2021 — 2023", title: "Master Cinéma & Audiovisuel", school: "Université Lumière Lyon 2", description: "Spécialité réalisation & écriture. Film de fin d'études sélectionné en festival." },
  { period: "2018 — 2021", title: "Licence Arts du spectacle", school: "Université Lumière Lyon 2", description: "Analyse filmique, histoire du cinéma, ateliers pratiques." },
  { period: "2018", title: "Baccalauréat — option Cinéma", school: "Lycée Saint-Exupéry", description: "Mention bien." },
];

export const skills = [
  { category: "Montage & étalonnage", items: [
    { name: "Adobe Premiere Pro", level: 90 },
    { name: "DaVinci Resolve", level: 85 },
    { name: "After Effects", level: 65 },
  ] },
  { category: "Image & tournage", items: [
    { name: "Cadrage / chef opérateur", level: 80 },
    { name: "Éclairage", level: 70 },
    { name: "Sony FX3 · Blackmagic", level: 85 },
  ] },
  { category: "Écriture & production", items: [
    { name: "Scénario", level: 75 },
    { name: "Direction d'acteurs", level: 70 },
    { name: "Gestion de production", level: 60 },
  ] },
];

export const languages = {
  spoken: [
    { name: "Français", level: "Langue maternelle", value: 100 },
    { name: "Anglais", level: "Courant — C1", value: 85 },
    { name: "Espagnol", level: "Intermédiaire — B1", value: 55 },
  ],
  countries: [
    { name: "Islande", year: "2024", note: "Repérages d'un court-métrage" },
    { name: "Japon", year: "2023", note: "Série photo argentique" },
    { name: "Espagne", year: "2022", note: "Erasmus — Madrid" },
    { name: "Maroc", year: "2021", note: "Tournage documentaire" },
    { name: "Italie", year: "2019", note: "Festival de Venise" },
  ],
};

export const art = [
  { title: "Fin d'après-midi", medium: "Huile sur toile", year: "2024", image: "https://images.unsplash.com/photo-1619878627081-85dd33d8667e?crop=entropy&cs=srgb&fm=jpg&w=900&q=85" },
  { title: "Bleu mineur", medium: "Acrylique", year: "2023", image: "https://images.unsplash.com/photo-1541753866388-0b3c701627d3?crop=entropy&cs=srgb&fm=jpg&w=900&q=85" },
  { title: "Fragments", medium: "Technique mixte", year: "2023", image: "https://images.unsplash.com/photo-1633887091273-a3bd71efddde?crop=entropy&cs=srgb&fm=jpg&w=900&q=85" },
];

export const music = {
  intro: "La musique guide souvent mon montage. Cliquez sur un disque pour écouter un extrait, sans quitter la chambre.",
  // Extraits : "spotify" = lien d'album/titre Spotify (lecteur officiel, droits gérés par Spotify).
  // "audio" = votre propre fichier (ex. "/audio/mon-morceau.mp3" dans /public/audio) — uniquement si vous en avez les droits.
  records: [
    { artist: "Ennio Morricone", album: "Il était une fois dans l'Ouest", year: "1968", color: "#C85A32", spotify: "https://open.spotify.com/album/1mLXrA8oEtzeH6D45Zx4Bt" },
    { artist: "Radiohead", album: "In Rainbows", year: "2007", color: "#E69C24", spotify: "https://open.spotify.com/album/5vkqYmiPBYLaalcmjujWxK" },
    { artist: "Air", album: "Moon Safari", year: "1998", color: "#6E8B74", spotify: "https://open.spotify.com/album/5dmYtZVJ1bG9RyrZBRrkOA" },
    { artist: "Joe Hisaishi", album: "Le Voyage de Chihiro", year: "2001", color: "#3E5C76", spotify: "https://open.spotify.com/album/766a5fKJYFy9ii4Kz2bQy9" },
    { artist: "Nina Simone", album: "Pastel Blues", year: "1965", color: "#8C5A7A", spotify: "https://open.spotify.com/album/31pd81sWDaK2pP3ok5892z" },
  ],
  genres: ["Bandes originales", "Jazz", "Trip-hop", "Rock alternatif", "Musique classique"],
  artists: ["Wim Wenders", "Hayao Miyazaki", "Alejandro G. Iñárritu", "Paul Thomas Anderson", "Claude Monet", "One Piece", "Jujutsu Kaisen", "Frieren"],
};

export const sports = [
  { name: "Musculation", since: "Depuis 2019", detail: "3 séances par semaine — discipline et régularité." },
  { name: "Course à pied", since: "Depuis 2020", detail: "Semi-marathon de Lyon en 1h42." },
  { name: "Escalade", since: "Depuis 2022", detail: "Bloc en salle, falaise l'été." },
];

export const associative = [
  { period: "2022 — aujourd'hui", role: "Bénévole programmation", organization: "Festival du Court-Métrage de Lyon", description: "Visionnage et sélection des films, accueil des équipes." },
  { period: "2020 — 2023", role: "Président", organization: "Ciné-club étudiant « La Bobine »", description: "Projections hebdomadaires, débats et invitations de réalisateurs." },
  { period: "2021", role: "Atelier vidéo", organization: "MJC Croix-Rousse", description: "Initiation au tournage pour des adolescents." },
];

export const contact = {
  intro: "Un projet, un tournage, une envie de collaborer ? Laissez-moi un message, je réponds sous 48 h.",
};
